import { createRoute, Outlet } from "@tanstack/react-router";
import { SpendDataPage } from "pages/app/SpendDataPage";

import { rootRoute } from "../rootRoute";

export const spendLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/spend",
  staticData: { pageName: "", breadcrumbLabel: "Invoiced spend" },
  component: Outlet,
});

export const spendIndexRoute = createRoute({
  getParentRoute: () => spendLayoutRoute,
  path: "/",
  staticData: { pageName: "Invoiced spend" },
  component: SpendDataPage,
});

export const spendRouteTree = spendLayoutRoute.addChildren([spendIndexRoute]);
